import Vue from 'vue'
import VueRouter from 'vue-router'
import Tabbar from '@/views/layout/Tabbar'
import store from '@/store'
import { Toast } from 'vant'
import { getDefaultLandingPath } from '@/utils/auth'

Vue.use(VueRouter)

// 路由懒加载
const getComponent = (name, component) => () => import(`@/views/${name}/${component}.vue`)

const routes = [
  // {
  //   path: '/',
  //   redirect: '/home',
  //   component: getComponent('home', 'index')
  // },
  {
    path: '/',
    component: Tabbar,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'HomeIndex',
        component: getComponent('home', 'index'),
        meta: { title: '首页', keepAlive: true }
      },
      {
        path: '/customer/index',
        name: 'CustomerIndex',
        component: getComponent('customer', 'index'),
        meta: { title: '客户', keepAlive: true }
      },
      {
        path: '/contract/index',
        name: 'ContractIndex',
        component: getComponent('contract', 'index'),
        meta: { title: '合同', keepAlive: true }
      },
      {
        path: '/case/index',
        name: 'CaseIndex',
        component: getComponent('case', 'index'),
        meta: { title: '案件', keepAlive: true }
      },
      {
        path: '/user/index',
        name: 'UserIndex',
        component: getComponent('user', 'index'),
        meta: { title: '我的', keepAlive: true }
      },
      {
        path: '/home/pool',
        name: 'HomePool',
        component: getComponent('home', 'pool'),
        meta: { title: '公海列表', keepAlive: true }
      },
      {
        path: '/home/dealCustomer',
        name: 'HomeDealCustomer',
        component: getComponent('home', 'dealCustomer'),
        meta: { title: '已成交列表', keepAlive: true }
      },
      {
        path: '/home/taNoSign',
        name: 'HomeTaNoSign',
        component: getComponent('home', 'taNoSign'),
        meta: { title: '已谈未签', keepAlive: true }
      }
    ]
  },
  {
    path: '/customer/detail',
    name: 'CustomerDetail',
    component: getComponent('customer', 'detail'),
    meta: { title: '客户详情', keepAlive: false }
  },
  {
    path: '/customer/create',
    name: 'CustomerCreate',
    component: getComponent('customer', 'create'),
    meta: { title: '新建客户', keepAlive: false }
  },
  {
    path: '/customer/createLeads',
    name: 'CustomerCreateLeads',
    component: getComponent('customer', 'createLeads'),
    meta: { title: '新建线索', keepAlive: false }
  },
  {
    path: '/contract/create',
    name: 'ContractCreate',
    component: getComponent('contract', 'create'),
    meta: { title: '新建合同', keepAlive: false }
  },
  {
    path: '/contract/detail',
    name: 'ContractDetail',
    component: getComponent('contract', 'detail'),
    meta: { title: '合同详情', keepAlive: false }
  },
  {
    path: '/receivables/create',
    name: 'ReceivablesCreate',
    component: getComponent('receivables', 'create'),
    meta: { title: '新建付款', keepAlive: false }
  },
  {
    path: '/receivables/detail',
    name: 'ReceivablesDetail',
    component: getComponent('receivables', 'detail'),
    meta: { title: '付款详情', keepAlive: false }
  },
  {
    path: '/receivables/billing',
    name: 'ReceivablesBilling',
    component: getComponent('receivables', 'billing'),
    meta: { title: '申请开票', keepAlive: false }
  },
  {
    path: '/travel/create',
    name: 'TravelCreate',
    component: getComponent('travel', 'create'),
    meta: { title: '出差申请', keepAlive: false }
  },
  {
    path: '/receivables/refund',
    name: 'ReceivablesRefundCreate',
    component: getComponent('receivablesRefund', 'create'),
    meta: { title: '退费减免申请', keepAlive: false }
  },
  {
    path: '/cost/create',
    name: 'CostCreate',
    component: getComponent('cost', 'create'),
    meta: { title: '费用报销', keepAlive: false }
  },
  {
    path: '/case/detail',
    name: 'CaseDetail',
    component: getComponent('case', 'detail'),
    meta: { title: '案件详情', keepAlive: false }
  },
  {
    path: '/contacts/create',
    name: 'ContactsCreate',
    component: getComponent('contacts', 'create'),
    meta: { title: '新建联系人', keepAlive: false }
  },
  {
    path: '/home/taskList',
    name: 'HomeTaskList',
    component: getComponent('home', 'taskList'),
    meta: { title: '待办页面', keepAlive: false }
  },
  {
    path: '/home/followUpRanking',
    name: 'HomeFollowUpRanking',
    component: getComponent('home', 'followUpRanking'),
    meta: { title: '跟进排名', keepAlive: false }
  },
  {
    path: '/user/personDetail',
    name: 'UserPersonDetail',
    component: getComponent('user', 'personDetail'),
    meta: { title: '个人信息', keepAlive: false }
  },
  {
    path: '/user/statistical',
    name: 'UserStatistical',
    component: getComponent('user', 'statistical'),
    meta: { title: '推广部总结', keepAlive: false }
  },
  {
    path: '/receivables/billDetail',
    name: 'ReceivablesBillDetail',
    component: getComponent('receivables', 'billDetail'),
    meta: { title: '开票详情', keepAlive: false }
  },
  {
    path: '/travel/detail',
    name: 'TravelDetail',
    component: getComponent('travel', 'detail'),
    meta: { title: '差旅详情', keepAlive: false }
  },
  {
    path: '/cost/detail',
    name: 'CostDetail',
    component: getComponent('cost', 'detail'),
    meta: { title: '费用报销详情', keepAlive: false }
  },
  {
    path: '/receivables/refundDetail',
    name: 'ReceivablesRefundDetail',
    component: getComponent('receivablesRefund', 'detail'),
    meta: { title: '退费减免详情', keepAlive: false }
  },
  {
    path: '/case/waitHandover',
    name: 'WaitHandover',
    component: getComponent('case', 'waitHandover'),
    meta: { title: '待交接案件', keepAlive: false }
  },
  {
    path: '/home/canCost',
    name: 'CanCost',
    component: getComponent('home', 'canCost'),
    meta: { title: '可报销案件', keepAlive: true }
  },
  {
    path: '/lawfirmContract/index',
    name: 'lawfirmContractIndex',
    component: getComponent('lawfirmContract', 'index'),
    meta: { title: '律所合同', keepAlive: true }
  },
  {
    path: '/lawfirmContract/detail',
    name: 'lawfirmContractDetail',
    component: getComponent('lawfirmContract', 'detail'),
    meta: { title: '合同详情', keepAlive: false }
  },
  {
    path: '/lawyerTools/index',
    name: 'LawyerTools',
    component: getComponent('lawyerTools', 'index'),
    meta: { title: '律师工具', keepAlive: true }
  },
  {
    path: '/followTemplate/create',
    name: 'FollowTemplateCreate',
    component: getComponent('customer', 'FollowTemplateEdit'),
    meta: { title: '新建跟进指导', keepAlive: false }
  },
  {
    path: '/cost/auditDetail',
    name: 'CostAuditDetail',
    component: getComponent('cost', 'auditDetail'),
    meta: { title: '费用报销审批详情', keepAlive: false }
  },
  {
    path: '/buckle/detail',
    name: 'BuckleDetail',
    component: getComponent('buckle', 'detail'),
    meta: { title: '补扣详情', keepAlive: false }
  },
  {
    path: '/bidding/index',
    name: 'BiddingIndex',
    component: getComponent('bidding', 'index'),
    meta: { title: '竞价统计', keepAlive: false }
  },
  {
    path: '/home/checkContract',
    name: 'CheckContract',
    component: getComponent('home', 'checkContract'),
    meta: { title: '待审合同', keepAlive: false }
  },
  {
    path: '/visit/index',
    name: 'VisitIndex',
    component: getComponent('visit', 'index'),
    meta: { title: '上门登记', keepAlive: false }
  },
  {
    path: '/visit/create',
    name: 'VisitCreate',
    component: getComponent('visit', 'create'),
    meta: { title: '添加上门登记', keepAlive: false }
  },
  {
    path: '/receivables/codepay',
    name: 'codepay',
    component: getComponent('receivables', 'codepay'),
    meta: { title: '收款', keepAlive: false }
  },
  {
    path: '/user/taRecord',
    name: 'TaRecord',
    component: getComponent('user', 'taRecord'),
    meta: { title: '谈案录音', keepAlive: true }
  },
  {
    path: '/redirect/action',
    name: 'RedirectAction',
    component: getComponent('redirect', 'action'),
    meta: { title: '操作', keepAlive: false }
  },
  {
    path: '/auth',
    name: 'AuthIndex',
    component: getComponent('user', 'authIndex'),
    meta: { title: '正版验证', keepAlive: false }
  },
  {
    path: '/contract/letterDetail',
    name: 'LetterDetail',
    component: getComponent('contract', 'letterDetail'),
    meta: { title: '所函详情', keepAlive: false }
  },
  {
    path: '/contract/letterCreate',
    name: 'LetterCreate',
    component: getComponent('contract', 'letterCreate'),
    meta: { title: '所函申请', keepAlive: false }
  },
  {
    path: '/contract/distribution',
    name: 'distribution',
    component: getComponent('contract', 'distribution'),
    meta: { title: '分配', keepAlive: false }
  },
  {
    path: '/404',
    component: () => import('@/views/404')
  },
  {
    path: '/login',
    component: () => import('@/views/login')
  },
  // personRouter,
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

const LOGIN_PATH = '/login'
const PUBLIC_AUTH_PATH = '/auth'

function hasLoadedUserInfo() {
  const userInfo = store.state.user.userInfo
  return Boolean(userInfo && userInfo.id)
}

/**
 * 保存登录完成后需要返回的原始路由，确保认证失败后不会丢失详情页深链接。
 */
function saveRedirectRoute(route) {
  if (route.path === LOGIN_PATH || route.path === PUBLIC_AUTH_PATH) return
  localStorage.setItem(
    'redirectUrl',
    JSON.stringify({
      path: route.path,
      query: route.query
    })
  )
}

function isUnauthorizedError(error) {
  const response = error && error.response
  const responseData = response && response.data
  return (
    Number(error && error.code) === 401 ||
    Number(response && response.status) === 401 ||
    Number(responseData && responseData.code) === 401
  )
}

async function clearInvalidSession(route) {
  saveRedirectRoute(route)
  await store.dispatch('user/resetToken', { preserveRedirect: true })
}

async function loadAuthenticatedContext() {
  // 正常情况下启动认证已经加载用户信息，此处兼容密码登录等其他入口。
  if (!hasLoadedUserInfo()) {
    await store.dispatch('user/getInfo', { skipSessionRecovery: true })
  }
  // 系统配置只在认证完成后加载，避免携带旧 Token 提前发起受保护请求。
  if (!store.state.system.crm_config) {
    await store.dispatch('system/crmGenConfig')
  }
}

router.beforeEach(async (to, from, next) => {
  // 正版验证页保持公开，不参与 Token 校验或钉钉认证。
  if (to.path === PUBLIC_AUTH_PATH) {
    next()
    return
  }

  try {
    // 有本地 Token 时优先静默校验；只有无 Token 或 Token 失效才会使用钉钉 Code。
    await store.dispatch('user/bootstrapSession')
  } catch (error) {
    await clearInvalidSession(to)
    if (!isUnauthorizedError(error)) {
      Toast.fail((error && error.message) || '自动登录失败，请使用密码登录')
    }
    if (to.path === LOGIN_PATH) {
      next()
    } else {
      next(LOGIN_PATH)
    }
    return
  }

  if (!store.state.user.token) {
    saveRedirectRoute(to)
    if (to.path === LOGIN_PATH) {
      next()
    } else {
      next(LOGIN_PATH)
    }
    return
  }

  try {
    await loadAuthenticatedContext()
  } catch (error) {
    await clearInvalidSession(to)
    if (to.path === LOGIN_PATH) {
      next()
    } else {
      next(LOGIN_PATH)
    }
    return
  }

  if (to.path === LOGIN_PATH) {
    Toast.fail('当前已登录')
    next(getDefaultLandingPath(store.state.user.userInfo))
    return
  }

  next()
})

export default router
